import Header from "../../components/Header";
import Compliances from "../../components/compliance/Compliances";
import PayrollMonthFilter from "../../components/compliance/PayrollMonthFilter";

const CompliancePage = () => {

    return (
        <div>
            <Header title="Compliances" />

            <PayrollMonthFilter />

           <Compliances />

        </div>
    );
};

export default CompliancePage;